/**
 * Links Domain Coordinator
 *
 * Coordinates cross-feature state changes when the current domain changes.
 * Resets links and table views state to ensure stale data from the previous
 * domain doesn't persist.
 *
 * @see Requirements 14.7
 */
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, mergeMap } from 'rxjs/operators';
import { from } from 'rxjs';

import * as DomainsActions from '../entities/domains/domains.actions';
import { linksActions } from '../../features/links/actions';
import { tableViewsActions } from '../../features/table-views/actions';

@Injectable()
export class LinksDomainCoordinatorEffects {
  private actions$ = inject(Actions);

  /**
   * Resets links and table views state when the domain changes.
   *
   * Dispatches:
   * - linksActions.resetState() to clear links entities and reset params
   * - tableViewsActions.clearActiveView() to deselect the active table view
   */
  resetOnDomainChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DomainsActions.setCurrentDomainId),
      filter((action) => action.domainId !== null),
      mergeMap(() =>
        from([
          linksActions.resetState(),
          tableViewsActions.clearActiveView(),
        ])
      )
    )
  );
}
